import type {CustomFormItemValue} from '../../../types';
import {getCustomFormItemTranslatedLabel} from '../../../utils';

export const getSelectOptionLabel =
	(value: CustomFormItemValue[]) => (option: string) => {
		const index = value.findIndex((val) =>
			typeof val === 'string' ? val === option : val.key === option,
		);
		if (index < 0) return '';

		const foundValue = value[index];
		return typeof foundValue === 'string'
			? foundValue
			: getCustomFormItemTranslatedLabel(foundValue);
	};
